import { Button, Row } from "antd";
import React from "react";
import Slider from "react-slick";
import { ROUTER_PATH, WIDTH_IPAD } from "../../common/constant";
import "./style.scss";
import _ from "lodash";
import { localizeRouteKey } from "../../shared/helpers";

const Stores = (props: any) => {
  const { sectionItem, history } = props;
  const { innerWidth } = window;

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: innerWidth > WIDTH_IPAD ? 2 : 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  };

  const showSlide = (data: any) =>
    data.map((d: any, i: number) => (
      <div key={i}>
        <img
          src={d.sub_images.length ? d.sub_images[0].galaries[0].path : ""}
          alt=""
          style={{ width: "100%" }}
        />
        <div className="location-title">
          <a href={d.url} target={d.target}>
            <span style={{ fontWeight: "bold" }}>{d.title}</span>
            <br />
            <span>{d.sub_title || ""}</span>
          </a>
        </div>
      </div>
    ));

  return sectionItem && sectionItem.children && sectionItem.children.length ? (
    <div className="kd-section-store">
      {/* <div className="mask-wrap" /> */}
      <div className="slide-text-wrap">
        <Row className="main-title">{sectionItem.title}</Row>
        <Row>
          <Button
            onClick={() =>
              history.push(localizeRouteKey(ROUTER_PATH.STORE_AGENCY))
            }
            className="see-all-btn">
            Xem tất cả
          </Button>
        </Row>
      </div>
      <Slider {...settings} className="images-slider">
        {showSlide(
          _.sortBy(
            sectionItem.children.filter((i: any) => !i.is_children_future),
            ["order"]
          )
        )}
      </Slider>
    </div>
  ) : null;
};

export default Stores;
